import { Button } from "@material-ui/core";
import { useMutation, useNotify } from "react-admin";
import { SchoolIdSelected } from "utils/tools";
import { calculationCostWidgetValidation } from "utils/validation";
import { memo, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

interface CalculationButtonProps {
  setResultCalculations: any;
  formData: any;
}

const useStyles = makeStyles({
  root: {
    marginLeft: 0,
  },
});

const CalculationAreaButton = ({
  setResultCalculations,
  formData,
}: CalculationButtonProps) => {
  const schoolId = Number(SchoolIdSelected());
  const notify = useNotify();
  const classes = useStyles();

  useEffect(() => {
    setResultCalculations(null);
  }, [formData]);

  const [HandleCalculation, { loading }] = useMutation(
    {
      type: "create",
      resource: `schools/${schoolId}/calculateArea`,
      payload: {
        data: {
          street: formData.locationData?.ROAD_NAME,
          unitNumber: 0,
          blockNumber: formData.locationData?.BLK_NO,
          building: formData.locationData?.BUILDING,
          address: formData.locationData?.ADDRESS,
          postalCode: formData.locationData?.POSTAL,
          lat: formData.locationData?.LATITUDE,
          lng: formData.locationData?.LONGITUDE,
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        setResultCalculations(res.json);
      },
      onFailure: (error) => {
        notify(`Failed Calculation, error: ${error.message}`, "warning");
      },
    }
  );

  return (
    <Button
      className={classes.root}
      variant="contained"
      color="primary"
      onClick={HandleCalculation}
      disabled={calculationCostWidgetValidation(formData)}
    >
      {loading ? "Loading.." : "Calculation"}
    </Button>
  );
};
export default memo(CalculationAreaButton);
